export const sleep = (milis: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, milis);
  });
